import { useMemo } from 'react';
import {
    Box,
    Typography,
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { formatDateTime } from "../../../utils/formatDateTime";
import MySubmissionsActionMenu from './MySubmissionsActionMenu';

// ── Column definitions ───────────────────────────────────────
export function useMySubmissionColumns({ onView, onEdit }) {
    return useMemo(() => [
        {
            field: 'id',
            headerName: 'ID',
            width: 100,
            renderCell: ({ value }) => (
                <Typography variant="body2" fontWeight={600} color="text.secondary">
                    #{value}
                </Typography>
            ),
        },
        {
            field: 'formName',
            headerName: 'Form',
            flex: 1,
            minWidth: 100,
            renderCell: ({ value }) => (
                <Box display="flex" alignItems="center" gap={1}>
                    <DescriptionOutlinedIcon sx={{ fontSize: 16, color: 'primary.main', flexShrink: 0 }} />
                    <Typography variant="body2" fontWeight={600} lineHeight={1.3}>
                        {value}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'createdAt',
            headerName: 'Submitted At',
            width: 180,
            renderCell: ({ value }) => (
                <Typography variant="body2" color="text.secondary">
                    {formatDateTime(value)}
                </Typography>
            ),
        },
        {
            field: 'updatedAt',
            headerName: 'Last Updated',
            width: 180,
            renderCell: ({ value }) => (
                <Typography variant="body2" color="text.secondary">
                    {formatDateTime(value)}
                </Typography>
            ),
        },
        {
            field: '__actions',
            headerName: '',
            width: 60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            align: 'center',
            renderCell: ({ row }) => (
                <MySubmissionsActionMenu row={row} onView={onView} onEdit={onEdit} />
            ),
        },
    ], [onView]);
}